export const classNames = (first, obj) => {
    const defaultValue = typeof first === 'string' ? first : '';
    const objToEvaluate = typeof first === 'object' ? first : obj || {};
    const result = Object.keys(objToEvaluate)
        .filter((key) => objToEvaluate[key])
        .join(' ');
    return `${defaultValue} ${result}`;
};
